import { ColorRadioGroupSkeleton, FormLayout, FormLayoutGroup, Skeleton } from "src/components"

export const CustomInteriorColorSkeleton = () => (
	<FormLayoutGroup>
		<Skeleton.Input withLabel />
		<ColorRadioGroupSkeleton count={8} />
		<FormLayout>
			<Skeleton.Input withLabel />
			<Skeleton.Checkbox />
		</FormLayout>
		<Skeleton.Input withLabel />
	</FormLayoutGroup>
)
